import React, { useEffect, useState } from "react";
import styles from "./DynamicForm.module.css";
import { ToastContainer } from "react-toastify";
import { notifyError } from "../../utils";
import axios from "axios";
import Cookies from "js-cookie";
import { uploadProfilePicture } from "../../services";
import { IoMdAddCircle } from "react-icons/io";
import { genreArray } from "../Onboarding";

const DynamicForm = ({
  fields,
  handleNextStep,
  setOnboardingData,
  profilePictureLoading,
  setProfilePictureLoading,
  handleUpsertProfile,
}) => {
  const [file, setFile] = useState(null);

  const [imageUrl, setImageUrl] = useState("");
  const [formData, setFormData] = useState({});
  const [fieldsToRender, setFieldsToRender] = useState(fields);
  const [searchTerm, setSearchTerm] = useState("");
  // For city search

  useEffect(() => {
    setOnboardingData(formData);
  }, [formData]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelect = (name, option, isMultiSelect) => {
    if (!isMultiSelect) {
      setFormData((prev) => {
        return { ...prev, [name]: [option] };
      });
      return;
    }

    setFormData((prev) => {
      const selectedItems = prev[name] || [];

      // If city is already selected, allow removal
      if (selectedItems.includes(option)) {
        return {
          ...prev,
          [name]: selectedItems.filter((item) => item !== option), // Remove city
        };
      }

      // If not already selected, only add if we have fewer than 3 items
      if (selectedItems.length === 3 && name === "name") {
        notifyError("You can select upto 3 categories");
        return prev;
      }

      return {
        ...prev,
        [name]: [...selectedItems, option], // Add city
      };
    });

    setSearchTerm(""); // Clear input after selection
  };

  const handleFileChange = async (event) => {
    const localFile = event.target.files[0];
    if (!localFile) return;

    setFile(localFile);

    // Only proceed if localFile is a valid Blob
    if (localFile instanceof Blob) {
      // Show preview
      const reader = new FileReader();
      reader.onloadend = () => {
        const previewImage = document.getElementById("image-preview");
        if (previewImage) {
          previewImage.src = reader.result;
        }
      };
      reader.readAsDataURL(localFile);

      // Prepare data for upload
      const uploadData = new FormData();
      uploadData.append("media", localFile);

      setProfilePictureLoading(true);

      try {
        handleUpsertProfile(true);
        const response = await fetch(uploadProfilePicture, {
          method: "POST",
          body: uploadData,
          headers: {
            authorization: `Bearer ${Cookies.get("accessToken")}`,
          },
        });

        if (response?.ok) {
          setFormData((prev) => ({
            ...prev,
            photo: localFile,
          }));
        } else {
          notifyError("Error while uploading Profile Picture!");
        }
      } catch (error) {
        notifyError("Something went wrong during upload.");
        console.error(error);
      } finally {
        setProfilePictureLoading(false);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
      notifyError("Please select file");
      return;
    }

    const formData = new FormData();
    formData.append("arnold", file);

    try {
      const response = await axios.post(
        "http://localhost:9000/media/upload?isDisplayPicture=true",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Cookies.get("accessToken")}`,
          },
        }
      );

      if (response.data?.file?.status === 200) {
        setImageUrl(response.data.file.data.Location);
      } else {
        alert("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      notifyError("Somehting went wrong while uploading");
    }
  };

  const removeCity = (name, city) => {
    setFormData((prev) => ({
      ...prev,
      [name]: prev[name].filter((item) => item !== city),
    }));
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (handleNextStep) handleNextStep();
  };

  return (
    <>
      <form onSubmit={submitForm} className={styles.formContainer}>
        {fields.map((field, index) => (
          <div key={index} className={styles.formGroup}>
            {field.label && (
              <label className={styles.label}>{field.label}</label>
            )}

            {/* Standard Text & Date Input */}
            {(field.type === "text" || field.type === "dob") && (
              <>
                {field.isMultiLine ? (
                  <textarea
                    rows={12}
                    type={field.type === "dob" ? "date" : "text"}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={formData[field.name] || ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                    className={`${styles.input} ${
                      field?.fullwidth ? styles.fullwidth : ""
                    }`}
                  />
                ) : (
                  <input
                    type={field.type === "dob" ? "date" : "text"}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={formData[field.name] || ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                    className={`${styles.input} ${
                      field?.fullwidth ? styles.fullwidth : ""
                    }`}
                  />
                )}
              </>
            )}

            {/* Multi-Select Pills */}
            {field.type === "pills" && (
              <div className={styles.pillContainer}>
                {field.options.map((option) => (
                  <button
                    type="button"
                    key={option.id}
                    className={`${styles.pill} ${
                      formData[field.name]?.includes(option.label) ||
                      formData[field.name]?.includes(option.value) ||
                      formData[field.name]?.includes(option.key)
                        ? styles.selectedPill
                        : ""
                    }`}
                    onClick={() =>
                      handleMultiSelect(
                        field.name,
                        field.name === "crowd_size_preference"
                          ? option.value
                          : genreArray.includes(field.name)
                          ? option.key
                          : option.label,
                        field.isMultiSelect
                      )
                    }
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}

            {/* Searchable Multi-Select (Pill-based) */}
            {field.type === "textPillSelection" && field.isMultiSelect && (
              <div className={styles.multiSelectContainer}>
                <input
                  type="text"
                  placeholder="Type to search cities..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={styles.inputSearch}
                  style={{ height: "40px" }}
                />

                {/* Suggested Cities */}
                {searchTerm && (
                  <div className={styles.suggestionsList}>
                    {field.options.filter((city) =>
                      city.toLowerCase().includes(searchTerm.toLowerCase())
                    ).length > 0 ? (
                      field.options
                        .filter((city) =>
                          city.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .slice(0, 10) // Limit results
                        .map((city) => (
                          <div
                            key={city}
                            className={styles.suggestionItem}
                            onClick={() =>
                              handleMultiSelect(field.name, city, true)
                            }
                          >
                            {city}
                          </div>
                        ))
                    ) : (
                      <div className={styles.noResults}>No matching city</div>
                    )}
                  </div>
                )}

                {/* Selected Cities as Pills */}
                <div className={styles.searchpillContainer}>
                  {(formData[field.name] || []).map((city) => (
                    <div key={city} className={styles.pillWithDelete}>
                      {city}
                      <button
                        type="button"
                        className={styles.delete}
                        onClick={() => removeCity(field.name, city)}
                      >
                        ❌
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* File Upload (Photos) */}
            {field.type === "photo" && (
              // <div className={styles.fileUploadContainer}>
              //   <div>
              //     <input
              //       type="file"
              //       accept="image/*"
              //       onChange={(e) => handleFileChange(e)}
              //     />
              //   </div>

              //   {file && (
              //     <div className={styles.previewContainer}>
              //       <img
              //         id="image-preview"
              //         alt="Preview"
              //         className={styles.previewImage}
              //         style={{
              //           maxWidth: "100px",
              //           maxHeight: "100px",
              //           objectFit: "cover",
              //         }}
              //       />
              //     </div>
              //   )}
              // </div>
              <div className={styles.fileUploadContainer}>
                <div className={styles.center}>
                  <div className={styles.customFileUpload}>
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      className={styles.uploadButton}
                    >
                      {file ? "Edit Image" : "Choose Image"}
                    </button>
                    <input
                      id="fileInput"
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }} // Hide the real input
                    />
                  </div>
                </div>
                {(file || formData.photo) && (
                  <div className={styles.previewContainer}>
                    <img
                      id="image-preview"
                      alt="Preview"
                      className={styles.previewImage}
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        objectFit: "cover",
                        border: "2px solid white",
                      }}
                    />
                  </div>
                )}
                {profilePictureLoading && (
                  <span className={styles.loadingProfileLablel}>
                    Please wait while uploading profile picture...
                  </span>
                )}
              </div>
            )}

            {/* Video Links Input */}
            {field.type === "video" && (
              <div className={styles.videoInputContainer}>
                <div className={styles.videoInputGroup}>
                  <input
                    type="text"
                    placeholder="Enter video URL"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={styles.input}
                  />
                  <IoMdAddCircle
                    onClick={() => {
                      const isValidYoutubeUrl =
                        /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(
                          searchTerm
                        );

                      if (!isValidYoutubeUrl) {
                        notifyError("Enter valid YouTube URL");
                        return;
                      }

                      handleChange(field.name, [
                        ...(formData[field.name] || []),
                        { mediaLink: searchTerm.trim() },
                      ]);

                      setSearchTerm(""); // Clear input after adding
                    }}
                    style={{
                      height: "30px",
                      width: "30px",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Display added video links */}
                <div className={styles.videoList}>
                  {(formData[field.name] || []).map((video, idx) => (
                    <div key={idx} className={styles.videoItem}>
                      <span rel="noopener noreferrer">
                        {video?.mediaLink?.length < 30
                          ? video?.mediaLink
                          : video?.mediaLink.substring(0, 30) + "..."}
                      </span>
                      <button
                        type="button"
                        style={{ background: "none" }}
                        onClick={() =>
                          handleChange(
                            field.name,
                            formData[field.name].filter(
                              (v) => v !== video?.mediaLink
                            )
                          )
                        }
                      >
                        ❌
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </form>
    </>
  );
};

export default DynamicForm;
